import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  SimpleGrid,
  Box,
  Icon,
  Divider,
  Body,
} from '@hover/blueprint';
import { nanoid } from 'nanoid';
import { INVITED_BY_CONTRACTOR_LIST_DATA } from '../../../constants';
import { Progress } from '../../ui';
import HoverMaterials from '../../../assets/videos/Hover_Materials.mp4';

interface Props {
  currentIndex: string;
  resetTimer: (title: string) => void;
}

const TabSectionDesktop: React.FC<Props> = ({ currentIndex, resetTimer }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const onReset = (title: string) => {
    resetTimer(title);
  };

  useEffect(() => {
    if (videoRef.current && currentIndex === 'TRANSPARENCY') {
      void videoRef.current.play();
    }
  }, [currentIndex]);

  return (
    <Container centerContent maxW="1200px" d={{ base: 'none', tablet: 'flex' }}>
      {INVITED_BY_CONTRACTOR_LIST_DATA.map(listItem => (
        <Box
          key={listItem.title}
          d={listItem.title === currentIndex ? 'flex' : 'none'}
          alignItems="center"
          justifyContent="center"
          w="100%"
          maxH="355px"
        >
          {listItem.title !== 'TRANSPARENCY' ? (
            <Box maxH="355px" minH="355px" key={nanoid()}>
              {listItem.desktopImage}
            </Box>
          ) : (
            <Box maxH="355px" minH="355px">
              <video
                ref={videoRef}
                src={HoverMaterials}
                muted
                key={nanoid()}
                playsInline
              />
            </Box>
          )}
        </Box>
      ))}
      <SimpleGrid columns={4} spacing={0} w="100%">
        {INVITED_BY_CONTRACTOR_LIST_DATA.map(listItem => {
          const isCurrent = listItem.title === currentIndex;
          return (
            <Box
              cursor="pointer"
              flexDir="column"
              alignItems="flex-start"
              mt={800}
              onClick={() => onReset(listItem.title)}
            >
              <Icon
                mb="20px"
                icon={listItem.icon}
                size="large"
                color={isCurrent ? 'brandNavy.500' : 'neutral.500'}
              />
              {isCurrent && !isLoading ? (
                <Progress />
              ) : (
                <Divider color="neutral.300" my={0} />
              )}
              <Body
                letterSpacing="2px"
                mt={800}
                mb={400}
                size={500}
                isBold
                lineHeight="20px"
                color={isCurrent ? 'brandNavy.500' : 'neutral.500'}
              >
                {listItem.title.toUpperCase()}
              </Body>
              <Body
                maxW="90%"
                size={600}
                fontWeight={isCurrent ? 300 : 400}
                color={isCurrent ? 'neutral.700' : 'neutral.500'}
              >
                {listItem.body}
              </Body>
            </Box>
          );
        })}
      </SimpleGrid>
    </Container>
  );
};

export default TabSectionDesktop;
